export default {
  AdmissionTable: {
    AdmissionTitle: 'Xét tuyển / {group}',
    EnrollmentStudentCode: 'Mã hồ sơ',
    FullName: 'Họ tên',
    Gender: 'Giới tính',
    DateOfBirth: 'Ngày sinh',
    Created: 'Ngày đăng ký',
    Description: 'Ghi chú',
    EnrollmentFeedBack: 'Phản hồi',
    ProfileType: 'Hình thức nộp',
    ReturnProfile: 'Đã gửi trả hồ sơ',
    EnrollmentStatus: 'Trạng thái',
    NotifyStatus: 'Gửi thông báo',
    MessageConfirmDelete: 'Thầy/cô có chắc muốn xóa <b>{numberRecord}</b> hồ sơ được chọn',
    Policy: 'Diện ưu tiên, Khuyết tật, Khuyến khích',
    Accommodation: 'Nơi ở hiện nay/ Địa chỉ tạm trú',
    PermanentResidence: 'Hộ khẩu thường trú',
    BirthQuality: 'Không đúng độ tuổi',
    InappropriateLevels: 'Trái tuyến',
    Prioritized: 'Diện ưu tiên/khuyết tât: {prioritize}',
    Note: 'Ghi chú: {note}',
    DateRegister: 'Ngày đăng ký: {date}',
    FatherFullName: 'Họ tên bố',
    MotherFullName: 'Họ tên mẹ',
    Period: 'Đợt đăng ký',
    PeriodDisplay: 'Đợt {period}',
    EmptyEnrollmentGroup: 'Chưa có nhóm tuyển sinh',
    EmptyEnrollmentGroupMessage: 'Vui lòng ấn <b>Thêm mới</b> để thêm mới Nhóm tuyển sinh',
    EthnicName: 'Dân tộc',
    AdditionServices: 'Dịch vụ đăng ký',
  },

  CreateAdmission: {
    StudentInformation: 'Thông tin cá nhân của học sinh',
    FullName: 'Họ và tên',
    TypeFullName: 'Nhập họ và tên',
    Gender: 'Giới tính',
    Choose: 'Chọn',
    Ethnic: 'Dân tộc',
    Nationality: 'Quốc tịch',
    DateOfBirth: 'Ngày sinh',
    PlaceOfBirth: 'Nơi sinh',
    TypingPlaceOfBirth: 'Nhập nơi sinh, bệnh viện,...',
    HomeTown: 'Quê quán',
    TypingHomeTown: 'Nhập quê quán',
    Policy: 'Diện ưu tiên',
    IDNumber: 'Số định danh cá nhân',
    TypingIDNumber: 'Nhập số định danh cá nhân',
    TypingPolicy: 'Chọn đối tượng',
    Disability: 'Khuyết tật',
    TypingDisability: 'Chọn loại khuyết tật',
    Promotes: 'Khuyến khích',
    TypingPromotes: 'Chọn loại khuyến khích',
    OldSchool: 'Tên trường cấp dưới',
    TypingOldSchool: 'Nhập tên trường cấp dưới',
    Description: 'Ghi chú',
    TypingDescription: 'Nhập ghi chú',
    EnrollmentGroup: 'Nhóm tuyển sinh',
    TypingEnrollmentGroup: 'Chọn nhóm',
    PermanentResidence: 'Hộ khẩu thường trú',
    EnrollmentGroupTitle: 'Chọn nhóm tuyển sinh',
    Location: 'Quốc gia',
    Province: 'Tỉnh/Thành phố',
    TypingContactInformation: 'Vui lòng nhập số điện thoại và email (nếu có) để nhà trường liên hệ khi có kết quả ',
    TypingContactInformationMobile: 'Vui lòng nhập email và số điện thoại để nhà trường liên hệ khi có kết quả:',
    Attachment: 'Tệp đính kèm',
    AddAttachment: 'Chọn tệp',
    ProfileType: 'Loại hồ sơ',
    District: 'Quận/Huyện',
    Ward: 'Xã/Phường',
    Village: 'Khu phố/Thôn',
    TypingVillage: 'Nhập khu phố/thôn',
    Neighbor: 'Tổ/Xóm',
    TypingNeighbor: 'Nhập tổ/xóm',
    StreetNumber: 'Số nhà, đường',
    TypingStreetNumber: 'Nhập số nhà, đường,...',
    ContactInformation: 'Thông tin liên hệ',
    ContactName: 'Người liên hệ',
    TypingContactName: 'Nhập họ tên',
    TypingPhone: 'Nhập số điện thoại',
    Phone: 'Số điện thoại',
    TypingEmail: 'Nhập email',
    Email: 'Email',
    DadInformation: 'Thông tin cha',
    DadName: 'Họ và tên',
    YearBorn: 'Năm sinh',
    TypingYearBorn: 'Nhập năm sinh',
    TypingID: 'Nhập số CMND/CCCD',
    ID: 'Số CMND/CCCD',
    Career: 'Nghề nghiệp',
    TypingCareer: 'Nhập nghề nghiệp',
    MonInformation: 'Thông tin mẹ',
    GuardianInformation: 'Thông tin người giám hộ (nếu có)',
    CurrentResidence: 'Nơi ở hiện tại/ Địa chỉ tạm trú',
    NoAdditionService: 'Hiện tại nhà trường chưa mở thêm các dịch vụ đăng ký.',
    ValidateStringYearBorn: 'Nhóm tuyển sinh <b>{groupName}</b> hiện tại chỉ  tuyển những năm sinh <b>{stringYearBorn}</b>.<br/> Bạn có chắc chắn muốn tiếp tục?',
    StringYearBornInvalidMsg: 'Năm sinh không thuộc nhóm tuyển sinh ({stringYearBorn})',
    StudentInformationTitle: 'Thông tin cá nhân',
    AddressTitle: 'Địa chỉ cư trú',
    AdditionService: 'Dịch vụ đăng ký',
    AttachmentTitle: 'Hồ sơ',
    ContactTitle: 'Thông tin liên hệ',
    TitleStudentAttachment: 'Hồ sơ đính kèm',
    Continue: 'Tiếp theo ({step})',
    Save: 'Nộp hồ sơ',
    CreatedDate: 'Ngày nộp: ',
    EditInformation: 'Chỉnh sửa',
    LinkAccountMessage: 'Hồ sơ chưa được liết với tài khoản nào. Vui lòng liên kết tài khoản để kiểm tra kết quả tuyển sinh',
    NoData: 'Chưa cập nhật',
    NoDataV2: 'Không',
    ValidateFileSize: 'Tối đa 5Mb',
    FileIsRequired: '{name} không được để trống',
    FeedbackFromSchool: 'Phản hồi từ nhà trường:',
    SetInformationFrom: 'Lấy thông tin từ',
    Father: 'Cha',
    Mother: 'Mẹ',
    Guardian: 'Người giám hộ',
  },

  AdmissionGroup: {
    Admission: 'Xét tuyển',
    NewProfile: '<span style="color: #03AE66">+ {numberProfile}</span> Hồ sơ mới',
  },

  Button: {
    EditProfile: 'Sửa hồ sơ',
    FeedBack: 'Phản hồi phụ huynh học sinh',
    AddProfile: 'Thêm hồ sơ',
    ReplyPH: 'Phản hồi',
    ChangeState: 'Chuyển trạng thái',
    ReturnProfile: 'Gửi trả hồ sơ',
    Print: 'In',
    Import: 'Nhập khẩu',
    ViewDetail: 'Xem chi tiết',
    GroupSwitch: 'Chuyển nhóm',
    DeleteProfile: 'Xóa hồ sơ',
    GroupSwitchV2: 'Chuyển nhóm tuyển sinh',
    SettingColumn: 'Tùy chỉnh cột',
    ResizeScreen: 'Phóng to/thu nhỏ màn hình (F11)',
    EnterNumberSubmissions: 'Nhập số lượng hồ sơ nộp trực tiếp',
    ViewHistory: 'Lịch sử xét duyệt',
    ToRecruit: 'Lập kế hoạch',
  },

  SettingColumnPopup: {
    Title: 'Tùy chỉnh cột',
    Description: 'Tích chọn cột muốn hiển thị, kéo thả biểu tượng để thay đổi thứ tự cột',
    GetDefault: 'Lấy lại mặc định',
    ShortDescription: 'Config cột xét tuyển',
  },

  NotData: {
    Title: 'Chưa có hồ sơ nào được xét tuyển.',
    Description: 'Thầy/cô vui lòng <b>Thêm hồ sơ</b> hoặc <b>Nhập khẩu</b> hồ sơ vào phần mềm.',
    NotGroup: 'Thầy/cô vui lòng chọn <b>Lập kế hoạch</b> để bắt đầu thực hiện xét tuyển.',
  },

  EmptyDataGroup: {
    Title: 'Chưa có hồ sơ nào được xét tuyển do nhà trường chưa lập kế hoạch tuyển sinh.',
  },

  Commons: {
    EnrollmentFeedBack: 'Phản hồi của nhà trường',
    EnrollmentFeedBackPlaceHolder: 'Nhập thông tin phản hồi cho phụ huynh',
  },

  EnrollmentStatusPopup: {
    Title: 'Chuyển trạng thái',
    WaitReceive: 'Chờ tiếp nhận',
    Priority: 'Diện ưu tiên',
    ReachCriteria: 'Hồ sơ đạt tiêu chí',
    NotReachCriteria: 'Không đạt tiêu chí',
    Elect: 'Trúng tuyển',
    NotElect: 'Không trúng tuyển',
    Admission: 'Đã nhập học',
    AdmissionComplete: 'Đã xét tuyển',
    WaitAdmission: 'Chờ xét tuyển',
    WaitUpdate: 'Cần bổ sung',
    PlaceHolder: 'Nhập nội dung phản hồi/lý do không trúng tuyển',
  },

  ReturnProfilePopup: {
    Title: 'Yêu cầu bổ sung',
    Label: 'Nội dung phản hồi',
    ReturnProfileLabel: 'Cho phép nộp lại hồ sơ',
  },

  FeedBackPopup: {
    Title: 'Phản hồi phụ huynh',
    Comment: 'Thầy/cô đang chọn <b>{ count }</b> hồ sơ để phản hồi cho phụ huynh, vui lòng nhập nội dung muốn phản hồi.',
    CommentLimit: 'Thầy/cô đang chọn hồ sơ <b>{ names }</b> để phản hồi cho phụ huynh, vui lòng nhập nội dung muốn phản hồi.',
    PlaceHolder: 'Hồ sơ cần bổ sung/chỉnh sửa',
    LabelFeedBack: 'Nội dung phản hồi',
  },

  AdditionPopup: {
    Title: 'Yêu cầu bổ sung',
  },

  GroupSwitchPopup: {
    Title: 'Chuyển nhóm tuyển sinh',
    LabelSelectGroup: 'Chọn nhóm chuyển tới',
  },

  ViewHistoryEnrollmentStudentPopup: {
    Title: 'Lịch sử xét duyệt',
    ChangeDate: '<span>{ time }</span> - <span>{ date }</span>',
    Status: 'Trạng thái: <span style="font-weight: bold;margin-right: 4px;">{ oldStatus } </span>',
    NewStatus: ' => <span style="font-weight: bold;"> {newStatus}</span>',
    FeedBack: 'Phản hồi: {feedBack}',
  },

  TemplateReasonNotElect: {
    NotAccepted: {
      display: 'Không đúng tuyến',
      value: 'Hồ sơ không đúng tuyến tuyển sinh',
    },
    NotRankAcademic: {
      display: 'Không đúng độ tuổi',
      value: 'Hồ sơ không đúng độ tuổi tuyển sinh',
    },

    NotReachCriteria: {
      display: 'Không đạt tiêu chí',
      value: 'Hồ sơ không đạt tiêu chí',
    },
  },

  TemplateWaitUpdate: {
    MissingProfile: {
      Tag: 'Thiếu hồ sơ',
      Display: 'Hồ sơ tải lên thiếu hình ảnh, phụ huynh vui lòng scan lại hồ sơ',
    },
    WrongInfo: {
      Tag: 'Sai thông tin',
      Display: 'Thông tin hồ sơ nhập sai, phụ huynh vui lòng nhập lại thông tin',
    },
    BlurImage: {
      Tag: 'Hình ảnh mờ',
      Display: 'Hình ảnh tải lên chưa rõ nét, phụ huynh vui lòng scan lại hồ sơ',
    },
  },

  TemplacteAdditionalRequest: {
    MissingProfile: {
      Tag: 'Thiếu hồ sơ',
      Display: 'Hồ sơ tải lên thiếu hình ảnh, phụ huynh vui lòng scan lại hồ sơ',
    },
    WrongInfo: {
      Tag: 'Sai thông tin',
      Display: 'Thông tin hồ sơ nhập sai, phụ huynh vui lòng nhập lại thông tin',
    },
    BlurImage: {
      Tag: 'Hình ảnh mờ',
      Display: 'Hình ảnh tải lên chưa rõ nét, phụ huynh vui lòng scan lại hồ sơ',
    },
  },

  TemplateReturnProfile: {
    InappropriateLevels: {
      display: 'Không đúng tuyến',
      value: 'Hồ sơ không đúng tuyến tuyển sinh',
    },
    WrongInfo: {
      display: 'Sai thông tin',
      value: 'Thông tin khai báo không đúng với hồ sơ gốc',
    },
    BlurredImage: {
      display: 'Hình ảnh mờ',
      value: 'Hình ảnh hồ sơ không rõ nét',
    },
    MissingProfile: {
      display: 'Hồ sơ thiếu',
      value: 'Hồ sơ không đầy đủ, hình ảnh hồ sơ bị mất góc',
    },
  },

  TabEnrollmentAdmission: {
    All: 'Tất cả hồ sơ ({value})',
    WaitReceive: 'Chờ tiếp nhận ({value})',
    WaitAdmission: 'Chờ xét tuyển ({value})',
    Elect: 'Trúng tuyển ({value})',
    WaitUpdate: 'Chờ bổ sung ({value})',
    NotElect: 'Không trúng tuyển ({value})',
    Admission: 'Đã nhập học ({value})',
  },

  EnrollmentNotQuality: {
    All: 'Tất cả hồ sơ',
    EnrollmentValid: 'Hồ sơ hợp lệ',
    EnrollmentNotValid: 'Hồ sơ không hợp lệ',
  },

  Message: {
    FeedBackSuccess: 'Phản hồi thành công',
    ChangeStatusSuccess: 'Chuyển trạng thái thành công',
    SwitchGroupSuccess: 'Chuyển nhóm thành công',
    AlertDeleteOne: 'Thầy/cô có chắc muốn xóa hồ sơ của học sinh <b>{fullName}</b>?',
    AlertDeleteProfileOnline: 'Hồ sơ này được phụ huynh nộp trực tuyến. Thầy/cô không thể xóa.',
    ReturnProfileSuccess: 'Yêu cầu bổ sung thành công',
    ConfigColumnSuccess: 'Tùy chỉnh cột thành công',
    CreateAddmissionSuccess: 'Nộp hồ sơ thành công.',
    SaveAddmissionSuccess: 'Lưu hồ sơ thành công.',
  },
}
